import React, { useState, useEffect, createContext, useContext } from "react";
import {
  getAllReactions,
  getOrgReactions,
} from "../../modules/OrganizationReactions/hooks/ReactionsHooks";
import {
  getSingleQuickTale,
  getSingleUser,
} from "../../modules/OrganizationQuickTales/hooks/QuickTalesHooks";
import { getAllGAReactions } from "../../GeneralAdmin/modules/GAReactions/hooks/GAReactionsHooks";
import { useAuth } from "../../hooks";
import { getMostRecentUserContentReport } from "../../GeneralAdmin/modules/GAContentModeration/hooks/ContentReportsHooks";

export const ReactionsContext = createContext();
export const useReactionsContext = () => useContext(ReactionsContext);

export const ReactionsProvider = ({ children }) => {
  const { currentUser, organizationId } = useAuth();
  const [allReactions, setAllReactions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("status");
  // const [orderBy, setOrderBy] = useState("reactionTitle");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);

  //General Admin states
  const [allGAReactions, setAllGAReactions] = useState([]);
  //General Admin states

  // useEffect(() => {
  //   handleGetAllReactions();
  // }, []);

  const handleGetAllReactions = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getOrgReactions(
        organizationId ? organizationId : currentUser?.organization
      );
      // Use map to create a promise for each document
      const reactionsPromises = querySnapshot.docs.map(async (item) => {
        const quicktaleTemp = await getSingleQuickTale(item.data().quicktale);
        const qtCreatedUserTemp = await getSingleUser(
          quicktaleTemp?.data()?.createdBy
        );
        const userTemp = await getSingleUser(item.data().user);
        let reactionReportsTemp = await getMostRecentUserContentReport(item.id);
        // console.log(reactionReportsTemp);
        let statusTemp = "";

        // Extract the status from the report, if it exists
        reactionReportsTemp.forEach((doc) => {
          // console.log("report::", doc);
          statusTemp = doc?.status?.status;
        });

        return {
          ...item.data(),
          id: item.id,
          quicktaleData: quicktaleTemp?.data() ? quicktaleTemp.data() : {},
          userData: userTemp?.data() ? userTemp.data() : {},
          reportedStatus: statusTemp,
          qtCreatedByData: qtCreatedUserTemp?.data()
            ? qtCreatedUserTemp.data()
            : {},
        };
      });

      // Wait for all promises to resolve
      const reactions = await Promise.all(reactionsPromises);
      setAllReactions(reactions);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false); // Make sure this is defined and handled appropriately
    } finally {
      setLoading(false);
    }
  };

  //General Admin functions
  const handleGetAllGAReactions = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getAllGAReactions();
      // Use map to create a promise for each document
      const reactionsPromises = querySnapshot.docs.map(async (item) => {
        const quicktaleTemp = await getSingleQuickTale(item.data().quicktale);
        const qtCreatedUserTemp = await getSingleUser(
          quicktaleTemp?.data()?.createdBy
        );
        const userTemp = await getSingleUser(item.data().user);
        let reactionReportsTemp = await getMostRecentUserContentReport(item.id);
        // console.log(reactionReportsTemp);
        let statusTemp = "";

        // Extract the status from the report, if it exists
        reactionReportsTemp.forEach((doc) => {
          // console.log("report::", doc);
          statusTemp = doc?.status?.status;
        });
        return {
          ...item.data(),
          id: item.id,
          quicktaleData: quicktaleTemp?.data() ? quicktaleTemp.data() : {},
          userData: userTemp?.data() ? userTemp.data() : {},
          reportedStatus: statusTemp,
          qtCreatedByData: qtCreatedUserTemp?.data()
            ? qtCreatedUserTemp.data()
            : {},
        };
      });

      // Wait for all promises to resolve
      const reactions = await Promise.all(reactionsPromises);
      setAllGAReactions(reactions);
    } catch (error) {
      console.error("Error fetching data from Firestore:", error.message);
      setLoading(false); // Make sure this is defined and handled appropriately
    } finally {
      setLoading(false);
    }
  };
  //General Admin functions

  return (
    <ReactionsContext.Provider
      value={{
        handleGetAllReactions,
        allReactions,
        setAllReactions,
        loading,
        setLoading,
        //general admin section
        allGAReactions,
        setAllGAReactions,
        handleGetAllGAReactions,
        //general admin section
        order,
        setOrder,
        orderBy,
        setOrderBy,
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
      }}
    >
      {children}
    </ReactionsContext.Provider>
  );
};
